<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else>
      <FormPanel
          headline="Create Registration"
          :errors="errors"
          :company-id="portalCompany.attributes.company_id"
          :content-registration-categories="contentRegistrationCategories"
          :initial="{gallery_images: []}"
          @submit="submit"
      />
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from '../../../../../../../../components/Administration/ContentRegistrations/Panels/Form'
import LoadingContainer from '../../../../../../../../components/Layout/LoadingContainer'

export default {
  components: {FormPanel, LoadingContainer},

  props: {
    portal: {
      required: true
    },

    portalCompanyId: {
      required: true
    }
  },

  data() {
    return {
      portalCompany: null,
      contentRegistrationCategories: null,

      loading: true,

      errors: {}
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      Promise.all([
        http.get('/api/v2/portal-companies/' + this.portalCompanyId),
        http.get('/api/v2/content-registration-categories', {'filter[portal_id]': this.portal.id})
      ]).then(responses => {
        this.portalCompany = responses[0].data.data

        this.contentRegistrationCategories = responses[1].data.data

        this.loading = false

      })
    },

    submit(data) {
      http.post('/api/v2/content-registrations', {...data, portal_company_id: this.portalCompany.id})
          .then(() => {
            notify.success('The content registration was saved')

            this.$router.push('/portals/' + this.portal.id + '/content/registrations')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    }
  }
}
</script>
